<template>
    <HeadingContainer :addBottomPadding="false" heading="My Rentals & Listings">
        <div class="row mt3">
        
            <div class="col-xs-12">
                <RentalsMenuCard/>
                <ListingsMenuCard class="mt3"/>
                <InvoicesMenuCard class="mt3"/>
            </div>
            
        </div>
    </HeadingContainer>
</template>

<script>
import HeadingContainer from '@/components/layout/HeadingContainer.vue';
import RentalsMenuCard from '@/components/rentalsListings/menus/RentalsMenuCard.vue';
import ListingsMenuCard from '@/components/rentalsListings/menus/ListingsMenuCard.vue';
import InvoicesMenuCard from '@/components/rentalsListings/menus/InvoicesMenuCard.vue';

export default {
    components: {
        HeadingContainer,
        RentalsMenuCard,
        ListingsMenuCard,
        InvoicesMenuCard
    }
};
</script>
